/**
 * Alaska: App.js (PWA)
 * Data: Splash
 * @version 1.0
 */

document.addEventListener("alpine:init", () => {
    Alpine.data("Splash", () => ({
        visible: true,

        init() {
            const video = this.$el.querySelector("video");

            if (video) {
                video.muted = true;
                video.play().catch((err) => {
                    console.warn("Video autoplay failed", err);
                });
            }

            setTimeout(() => {
                this.hide();
            }, 6000); // fallback
        },

        hide() {
            this.visible = false;
        }
    }));
});